/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__expense_note_section__edit__include = /** @type {(inputs: {}) => string} */ () => {
	return `Folgende Elemente berücksichtigen`
};

const en_route_details__expense_note_section__edit__include = /** @type {(inputs: {}) => string} */ () => {
	return `Include the following elements`
};

const es_route_details__expense_note_section__edit__include = /** @type {(inputs: {}) => string} */ () => {
	return `Incluir los elementos siguientes`
};

const fr_route_details__expense_note_section__edit__include = /** @type {(inputs: {}) => string} */ () => {
	return `Inclure les éléments suivants`
};

const it_route_details__expense_note_section__edit__include = /** @type {(inputs: {}) => string} */ () => {
	return `Includere i seguenti elementi`
};

const nl_route_details__expense_note_section__edit__include = /** @type {(inputs: {}) => string} */ () => {
	return `De volgende elementen opnemen`
};

const pt_route_details__expense_note_section__edit__include = /** @type {(inputs: {}) => string} */ () => {
	return `Incluir os elementos seguintes`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__include = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__expense_note_section__edit__include(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__expense_note_section__edit__include", locale)
	if (locale === "de") return de_route_details__expense_note_section__edit__include(inputs)
	if (locale === "en") return en_route_details__expense_note_section__edit__include(inputs)
	if (locale === "es") return es_route_details__expense_note_section__edit__include(inputs)
	if (locale === "fr") return fr_route_details__expense_note_section__edit__include(inputs)
	if (locale === "it") return it_route_details__expense_note_section__edit__include(inputs)
	if (locale === "nl") return nl_route_details__expense_note_section__edit__include(inputs)
	return pt_route_details__expense_note_section__edit__include(inputs)
};